module.exports = __webpack_public_path__ + "img/red_footer.8c4c406f.png";